// A direct message's conversation opens on its letter, with no panel header row
// above it (panel.module.scss). The panel used to find out with
// `:has([data-direct-message-letter])`, but a :has() whose argument can match
// anywhere in the panel makes the browser re-check it, and restyle the whole
// panel, on every DOM insertion: each post that mounted while the feed
// scrolled. The letter marks its own panel instead, while it is mounted.

export const PANEL_LETTER_ATTRIBUTE = 'data-has-direct-message-letter'
const PANEL_SELECTOR = '.panel-container-comp'

type PanelLike = {
    setAttribute: (name: string, value: string) => void
    removeAttribute: (name: string) => void
}
type LetterLike = { closest: (selector: string) => PanelLike | null }

// Letters per panel, so one letter unmounting cannot clear the mark another still needs.
const lettersByPanel = new WeakMap<PanelLike, number>()

export function markPanelWithDirectMessageLetter(letter: LetterLike | null): () => void {
    const panel = letter?.closest(PANEL_SELECTOR)
    if (!panel) return () => {}

    lettersByPanel.set(panel, (lettersByPanel.get(panel) || 0) + 1)
    panel.setAttribute(PANEL_LETTER_ATTRIBUTE, 'true')

    let released = false
    return () => {
        if (released) return
        released = true
        const remaining = (lettersByPanel.get(panel) || 1) - 1
        if (remaining > 0) {
            lettersByPanel.set(panel, remaining)
            return
        }
        lettersByPanel.delete(panel)
        panel.removeAttribute(PANEL_LETTER_ATTRIBUTE)
    }
}
